import { Injectable } from '@angular/core';
import { DataFarmType } from 'src/app/domainObjects/dataFarmType';
import * as dataDictionaryJson from '../../../../../../app/transformers/resources/DataDict.json';
import { DataDictionaryType, DataDictionaryTypeUtil } from '../../domainObjects/dataDictionaryType';

export class DataDictionaryItem {
  index: number;
  Farm: string;
  Field: string;
  Type: string;
  Destination: string;
  DataType: string;
  PyDataType: string;
  Default: any;
  Units: any;
  Description: string;
}

@Injectable({
  providedIn: 'root'
})
export class DataDictionaryService {

  dataDictionary = JSON.parse(JSON.stringify(dataDictionaryJson));

  constructor() { }

  getColumns(type: DataDictionaryType = DataDictionaryType.all): Array<DataDictionaryItem> {
    const typeName = DataDictionaryTypeUtil.toString(type);
    //console.log(`Getting data dictionary for type: ${typeName} ...`);

    const dataList: Array<DataDictionaryItem> = this.dataDictionary.data;
    //console.log('DataDictionaryService dataList = ', dataList);

    if(type == DataDictionaryType.all){
      var columns = dataList
    }
    else{
      var columns = dataList.filter(i =>
        i.Farm == typeName
      );
    }
    //console.log('DataDictionaryService Columns 35 = ', columns);

    return columns;
  }
}
